import { IInvoiceModel, IInvoiceNoteModel, InvoiceModel, InvoiceNoteModel } from "@common/models";
import { InvoiceUpdateRequest } from "@common/models/requests";
import { InvoiceDiscountsRequest } from "@common/models/requests/InvoiceDiscountsRequest";
import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";

export class InvoiceService {
    private static baseUrl: string = '/api/invoice';

    public static tags = {
        getInvoiceById: "getInvoiceById",
        updateInvoice: "updateInvoice",
        exportSummaries: "exportSummaries",
        upsertInvoiceNote: "upsertInvoiceNote",
        upsertInvoiceDiscrepancyReason: "upsertInvoiceDiscrepancyReason",
        applyInvoiceDiscounts: "applyInvoiceDiscounts"
    }

    public static getInvoiceById = (invoiceId: number): Promise<InvoiceModel> =>
        trackPromise(new Promise<InvoiceModel>((resolve, reject) => {
            http(`${this.baseUrl}/${invoiceId}`)
                .get<IInvoiceModel>()
                .then(json => {
                    resolve(new InvoiceModel(json))
                })
                .catch(reject)
        }), this.tags.getInvoiceById);

    static updateInvoice = (invoiceId: number, request: InvoiceUpdateRequest): Promise<InvoiceModel> => {
        return trackPromise(new Promise<InvoiceModel>((resolve, reject) => {
            http(`${this.baseUrl}/${invoiceId}`).put<IInvoiceModel>(request)
                .then(json => new InvoiceModel(json))
                .then(resolve)
                .catch(reject)
        }), this.tags.updateInvoice);
    };

    static upsertInvoiceNote = (request: IInvoiceNoteModel): Promise<InvoiceNoteModel> =>
        trackPromise(new Promise<InvoiceNoteModel>((resolve, reject) => {
            http(`${this.baseUrl}/addnote`)
                .post<IInvoiceNoteModel>(request)
                .then(json => resolve(new InvoiceNoteModel(json)))
                .catch(reject)
        }), this.tags.upsertInvoiceNote);

    static upsertInvoiceDiscrepancyReason = (invoiceId: number, request: InvoiceUpdateRequest): Promise<InvoiceModel> => {
        return trackPromise(new Promise<InvoiceModel>((resolve, reject) => {
            http(`${this.baseUrl}/${invoiceId}/adddiscrepancy`).post<IInvoiceModel>(request)
                .then(json => new InvoiceModel(json))
                .then(resolve)
                .catch(reject)
        }), this.tags.upsertInvoiceDiscrepancyReason);
    };

    static applyInvoiceDiscounts = (request: InvoiceDiscountsRequest): Promise<InvoiceModel> => {
        return trackPromise(
            new Promise<InvoiceModel>((resolve, reject) => {
                const body = JSON.parse(JSON.stringify(request));
                http(`${this.baseUrl}/${request.invoiceId}/applyInvoiceDiscounts`)
                    .post<IInvoiceModel>(body).then((apt) => {
                        const invoice = new InvoiceModel(apt);
                        resolve(invoice);
                    }).catch((error) => {
                        reject(error);
                    });
            }), this.tags.applyInvoiceDiscounts);
    }
}
